<template>
  <div>
    <h1>Password Change</h1>

    <KadoMenu />

    <template v-if="idToken">

      <!-- session info area -->
      <div class="div-session">
        <font-awesome-icon icon="user" /> : {{ username }} <span @click="signOut">[ <font-awesome-icon icon="sign-out-alt" title="sign out" /> ]</span>
      </div>
      <hr />

    </template>

    <table class="table-passwdchange">
      <tr>
        <td>
          Old Password:
        </td>
        <td>
          <div class="div-passwdchange-inputText">
            <input class="inputText-common" type="password" placeholder="Old Password" v-model="oldPassword" required />
          </div>
        </td>
      </tr>
      <tr>
        <td>
          New Password:
        </td>
        <td>
          <div class="div-passwdchange-inputText">
            <input class="inputText-common" type="password" placeholder="New Password" v-model="newPassword" required />
          </div>
        </td>
      </tr>
      <tr>
      <tr>
        <td>
          New Password(confirm):
        </td>
        <td>
          <div class="div-passwdchange-inputText">
            <input class="inputText-common" type="password" placeholder="New Password(confirm)" v-model="newPasswordConfirm" required />
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <div class="div-passwdchange-button">
            <button class="button-normal button-normal__extra" @click="passwdChange" >Change</button>
          </div>
        </td>
      </tr>
    </table>

    <div class="div-procMsg-normal" v-if="procMsgNormal" >{{ procMsgNormal }}</div>
    <div class="div-procMsg-attention" v-if="procMsgAttention" >{{ procMsgAttention }}</div>
  </div>
</template>

<script>
// 共通定数
import { MyConfig as mc } from '@/MyConfig'
// 認証モジュール
import { MyAuth } from '@/my-modules/my-auth'
// コンポーネント：角メニュー
import KadoMenu from '@/components/KadoMenu.vue'

export default {
  name: 'PasswdChange',

  components: {
    KadoMenu
  },

  data () {
    return {
      oldPassword: '',
      newPassword: '',
      newPasswordConfirm: '',
      procMsgNormal: null,
      procMsgAttention: null,
      username: '',
      idToken: ''
    }
  },

  mounted: function () {
    this.checkSession()
  },

  methods: {

    /* =================================================================================
     * signOut
     *   サインアウト
     * ============================================================================== */
    signOut () {
      mc.LOG_LEVEL ? console.log('%c info: Method=signOut: Start', mc.LOG_TYPE_I) : (() => { })()
      const myAuth = new MyAuth()
      myAuth.signOut()
      this.username = ''
      this.idToken = ''
      this.$router.push('/auth/signin')
      mc.LOG_LEVEL ? console.log('%c info: Method=signOut: End', mc.LOG_TYPE_I) : (() => { })()
    },

    /* =================================================================================
     * checkSession
     *   認証セッションの状態をチェック
     * ============================================================================== */
    async checkSession () {
      mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: Start', mc.LOG_TYPE_I) : (() => { })()
      try {
        const myAuth = new MyAuth()
        const res = await myAuth.checkSession()
        if (res.status === 'OK') {
          mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: OK', mc.LOG_TYPE_I) : (() => { })()
          this.idToken = res.content.idToken
          this.username = res.content.username
        } else if (res.status === 'NOAUTH') {
          mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: NOAUTH', mc.LOG_TYPE_I) : (() => { })()
          this.WriteProcMsg('normal', res.content)
          setTimeout(() => { this.$router.push('/auth/signin') }, mc.MSG_TIMEOUT)
        }
      // モジュールmyAuth(promise)からのrejectや例外エラーをcatch
      } catch (e) {
        mc.LOG_LEVEL ? console.log('%c error: Method=checkSession: e:', mc.LOG_TYPE_E, e) : (() => { })()
        this.WriteProcMsg('attention', 'Failed to check session at the moment, try back later.')
      }
      mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: End', mc.LOG_TYPE_I) : (() => { })()
    },

    /* =================================================================================
     * passwdChange
     *   パスワードを変更
     * ============================================================================== */
    async passwdChange () {
      mc.LOG_LEVEL ? console.log('%c info: Method=passwdChange: Start', mc.LOG_TYPE_I) : (() => { })()
      this.resetProcMsg()
      if (this.oldPassword && this.newPassword && (this.newPassword === this.newPasswordConfirm)) {
        // 認証セッションの状態をチェック
        await this.checkSession()
        if (!this.idToken) { return false }
        const myAuth = new MyAuth()
        await myAuth.passwdChange(this.oldPassword, this.newPassword)
          .then(resutl => {
            mc.LOG_LEVEL ? console.log('%c info: Method=passwdChange: OK', mc.LOG_TYPE_I) : (() => { })()
            this.oldPassword = ''
            this.newPassword = ''
            this.newPasswordConfirm = ''
            this.WriteProcMsg('normal', 'Password has been changed, you can sign in with new password.')
            setTimeout(() => { this.$router.push('/auth/signin') }, mc.MSG_TIMEOUT)
          })
          .catch(err => {
            mc.LOG_LEVEL ? console.log('%c error: call=myAuth.passwdChange: err:', mc.LOG_TYPE_E, err) : (() => {})()
            this.WriteProcMsg('attention', JSON.stringify(err))
          })
      }
    },

    /* =================================================================================
     * WriteProcMsg
     *   メッセージ欄をブランクにする
     * ============================================================================== */
    WriteProcMsg (type, content) {
      if (type === 'normal') {
        this.procMsgNormal = content
        setTimeout(() => { this.procMsgNormal = null }, mc.MSG_TIMEOUT)
      } else if (type === 'attention') {
        this.procMsgAttention = content
        setTimeout(() => { this.procMsgAttention = null }, mc.MSG_TIMEOUT)
      }
    },

    /* =================================================================================
     * resetProcMsg
     *   メッセージ欄をブランクにする
     * ============================================================================== */
    resetProcMsg () {
      this.procMsgNormal = null
      this.procMsgAttention = null
    }
  }
}
</script>

<style scoped>
.div-session {
  text-align: right;
}
.div-session .fa-sign-out-alt {
  cursor: pointer;
}
.table-passwdchange {
  margin-left: auto;
  margin-right: auto;
}
.div-passwdchange-inputText {
  width: 15em;
  margin: 0 0.2em 0.2em 0.2em;
}
.div-passwdchange-button {
  padding: 1em 0;
  text-align: center;
}
.button-normal__extra {
  width: 10em;
}
</style>
